import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import type React from "react";

import theme from "@/theme/theme";

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider theme={theme}>
      <>{children}</>
      <CssBaseline />
    </ThemeProvider>
  );
}
